import React from "react";
import { Fonts } from "../../design/Font";

export default class Checkbox extends React.Component{

    render(){
        const {value,onChange,boxFirst,title} = this.props
        if(boxFirst)
            return(
                <div style={{display:'flex', flexDirection:'row', width:"100%"}}>
                    <input style={{}} type="checkbox" onChange={onChange} checked={value}/>
                    <span style={{...Fonts.subtext,cursor:'pointer', alignSelf:'center'}} onClick={onChange}>{title}</span>
                </div>
            ) 
        else
            return(
                <div style={{display:'flex', flexDirection:'row', width:"100%", height:'15%'}}>
                    <span style={{...Fonts.subtext, cursor:'pointer'}} onClick={onChange}>{title}</span>
                    <input type="checkbox" onChange={onChange} checked={value}/>
                </div>
            )
    }
}